import { createContext } from 'react';

export const HttpPopupContext = createContext();